var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":_vm.openAddDialog}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-account-plus")]),_c('p',{staticClass:"ma-0 mt-1"},[_vm._v(" "+_vm._s(_vm.isTherapist ? _vm.$t('therapist.add-patient') : _vm.$t('teacher.add-student'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }